module.exports = __webpack_public_path__ + "img/big5-5.aaa24ec4.jpg";